export const RANGE_TYPE_LABELS = {
  CUSTOM: "cs",
  HOUR_1: "1h",
  HOUR_2: "2h",
  HOUR_12: "12h",
  HOUR_24: "24h",
  DAY_1: "1d",
  DAY_MINUS_1: "-1d",
  DAY_7: "7d",
  DAY_15: "15d",
  DAY_30: "30d",
};

export const customRanges = [
  { label: "Past 1 Hour", value: RANGE_TYPE_LABELS.HOUR_1, noOfDays: 1 },
  { label: "Past 2 Hours", value: RANGE_TYPE_LABELS.HOUR_2, noOfDays: 1 },
  { label: "Past 12 Hours", value: RANGE_TYPE_LABELS.HOUR_12, noOfDays: 1 },
  { label: "Last 24 Hours", value: RANGE_TYPE_LABELS.HOUR_24, noOfDays: 1 },
  { label: "Today", value: RANGE_TYPE_LABELS.DAY_1, noOfDays: 1 },
  { label: "Yesterday", value: RANGE_TYPE_LABELS.DAY_MINUS_1, noOfDays: 1 },
  { label: "Past 7 Days", value: RANGE_TYPE_LABELS.DAY_7, noOfDays: 7 },
  { label: "Past 15 Days", value: RANGE_TYPE_LABELS.DAY_15, noOfDays: 15 },
  { label: "Past 30 Days", value: RANGE_TYPE_LABELS.DAY_30, noOfDays: 30 },
  { label: "Custom", value: RANGE_TYPE_LABELS.CUSTOM, noOfDays: -1 },
];

export const DEFAULT_TIME_RANGE = RANGE_TYPE_LABELS.DAY_7;

export const TEXT_LIBRARY = {
  NO_DATA_AVAILABLE: "No data available",
  START_TIME: "Start Time",
  END_TIME: "End Time",
  INVALID_CREDENTIALS: "Invalid email or password. Please try again.",
  LOGIN_TOO_MANY_ATTEMPTS: "Too many failed sign-in attempts. Please try again in {duration}.",
  NO_ACTIVE_SITEID_FOUND: "No active site ID was found for this charger.",
  ERROR_IN_FETCHING_SITEID: "Error in fetching siteId",
  SERVER_ERROR: "Server error. Please try again",
};

export const SNACKBAR_CONSTANTS = {
  HIDE_DURATION: 5000,
};

export const PLACEHOLDER_TEXT = {
  SEARCH_CHARGER_ID: "Search by Charger ID...",
};

export const DATE_FORMAT_YYYYMMDD = "YYYYMMDD";

export const ACCENT_COLOR = "#f47c20";

export const TIMEZONE_LABEL_SX = {
  width: "auto",
  px: 0.5,
  fontSize: "0.75rem",
  fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
  color: "text.secondary",
  fontWeight: 400,
  ml: 0.5,
  cursor: "default",
};

export const CHART_CONSTANTS = {
  MIN_ZOOM_WINDOW_MS: 5000,
  EXPORT_FILENAME_CSV: "connection-status.csv",
  EXPORT_FILENAME_XLSX: "connection-status.xls",
  EXPORT_FILENAME_PNG: "connection-status.png",
  EXPORT_SHEET_NAME: "Connection Status",
  TOOLTIP_OFFSET_X: 15,
  TOOLTIP_OFFSET_Y: 20,
  TOOLTIP_EDGE_PADDING: 10,
  TOOLTIP_TOP_PADDING: 5,
  TOOLTIP_DEFAULT_WIDTH: 200,
  TOOLTIP_DEFAULT_HEIGHT: 100,
  X_AXIS_TICK_COUNT: 8,
  Y_AXIS_TICK_COUNT: 6,
};
